import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, Redirect, withRouter } from 'react-router'
import SwitchCSSTransitionGroup from 'switch-css-transition-group'
import Icon from 'components/icon/icon'
import {
	openModal,
	changeTitle,
	favouriteProject,
	setOnboardingStep
} from 'state/actions'

import MainHeaderNav from '../../main-header-nav'
import Dateprogress from 'components/date-progress/date-progress'

import ProjectReporting from './project-reporting/project-reporting'
import ProjectActivity from './project-activity/project-activity'
import ProjectNotes from './project-notes/project-notes'
import ProjectTasks from './project-tasks/project-tasks'
import ProjectFiles from './project-files/project-files'
import ProjectMeetings from './project-meetings/project-meetings'

import ProjectBreadcrumbs from './project-breadcrumbs'
import MobileSubMenu from 'components/mobile/mobile-sub-menu'

import ProfilePicture from 'components/profile/profile-picture'

import queryString from 'query-string'

import {
	isMobile,
	isProjectFavourited,
	scrollToTop
} from 'utils'

import { MainContext } from 'context'

class ProjectIndex extends Component {
	constructor(props) {
		super(props)

		this.hasOpenedEditFromQuery = false

		this.navtabs = [
			{
				name: 'Activity',
				path: 'activity',
				component: props => (
					<ProjectActivity {...props} />
				)
			},
			{
				name: 'Notes',
				path: 'notes',
				count: true,
				component: props => (
					<ProjectNotes {...props} />
				)
			},
			{
				name: 'Files',
				path: 'files',
				count: true,
				component: props => (
					<ProjectFiles {...props} />
				)
			},
			{
				name: 'Tasks',
				path: 'tasks',
				component: props => (
					<ProjectTasks {...props} />
				)
			},
			{
				name: 'Gantts',
				path: 'gantts',
				hidden: true,
				component: props => {
					return (
						<ProjectTasks {...props} />
					)
				}

			}
		]
	}

	componentWillMount = _ => {
		const {
			roles,
			user
		} = this.context

		const {
			currentAccount,
			setOnboardingStep
		} = this.props

		if (roles.guest) {
			this.navtabs.splice(0, 1)
		}

		if (isMobile()) {
			// Don't add any extra tabs on mobile
			return
		}

		if (user) {
			setOnboardingStep('OPENED_PROJECT', user)
		}

		if (currentAccount && currentAccount.has_meetings) {
			const notesIndex = this.navtabs.findIndex(tab => {
				return tab.path == 'notes'
			})

			this.navtabs[notesIndex] = {
				name: 'Meetings',
				path: 'meetings',
				count: true,
				component: props => (
					<ProjectMeetings {...props} />
				)
			}
		}

		this.addReportingTab()
	}

	componentWillUnmount() {
		window.requestAnimationFrame(_ => {
			scrollToTop()
		})
	}

	shouldComponentUpdate = nextProps => {
		if (this.props.activeHeaderTab !== nextProps.activeHeaderTab) {
			return false
		}

		return true
	}

	componentDidMount = _ => {
		const {
			projectScrollHeight,
			currentProject,
			changeTitle
		} = this.props

		// Scroll to previous position if coming from single task.
		const scrollHeight = projectScrollHeight ? projectScrollHeight : 0

		if (currentProject.name) {
			changeTitle(currentProject.name)
		}

		setTimeout(_ => {
			window.scrollTo(0, scrollHeight)
		}, scrollHeight > 0 ? 200 : 0) // if it's been set to anything, we're probably watiing on a transition.

		this.checkForQueryCommand()
	}

	componentWillUpdate = _ => {
		this.addReportingTab()
	}

	componentDidUpdate = prevProps => {
		const {
			currentProject,
			changeTitle,
			location
		} = this.props

		if (currentProject && this.props.currentProject.name) {
			const oldProject = prevProps.currentProject
			const newProject = currentProject

			let shouldUpdateTitle = false

			if (oldProject) {
				if ((!oldProject.name && newProject.name) || (oldProject.name && oldProject.name !== newProject.name)) {
					shouldUpdateTitle = true
				}
			}

			if (shouldUpdateTitle) {
				changeTitle(currentProject.name)
			}
		}

		this.checkForQueryCommand()
	}

	addReportingTab = _ => {
		if (isMobile()) {
			return
		}

		const {
			userRoles,
			isPremium
		} = this.props

		if (this.navtabs[0].path === 'activity' && (userRoles.pm || userRoles.admin) && isPremium) {
			this.navtabs[0] = {
				name: 'Reporting',
				path: 'reporting',
				component: props => {
					return (
						<ProjectReporting {...props} />
					)
				}
			}
		}
	}

	checkForQueryCommand = _ => {
		const {
			location,
			openModal,
			currentProject
		} = this.props

		if (location.search && !this.hasOpenedEditFromQuery) {
			const thisQueryString = location.search
			const queries = queryString.parse(thisQueryString)

			if (typeof queries.openEdit !== 'undefined') {
				this.hasOpenedEditFromQuery = true

				openModal('edit', 'project', {
					...currentProject
				})
			}
		}
	}

	selectProjecttab = name => {
		this.setState({ activeProjecttab: name });
	}

	dismissProjecttab() {
		this.setState({ activeProjecttab: null });
	}

	deleteProject = _ => {
		this.props.openModal('delete', 'project', { data: this.props.currentProject });
	}

	editProject = (duplicate, type) => {
		const {
			openModal,
			currentProject
		} = this.props

		openModal('edit', 'project', {
			...currentProject,
			duplicate,
			forceType: type
		})
	}

	restoreProject = _ => {
		const {
			openModal,
			currentProject
		} = this.props

		openModal('restore', 'project', {
			data: currentProject
		})
	}

	favouriteProject = _ => {
		const {
			favouriteProject,
			currentProject
		} = this.props

		const {
			user
		} = this.context

		favouriteProject(currentProject, user)
	}

	render() {
		const {
			location,
			loading,
			currentAccount,
			currentProject,
			hasHardSetState,
			match,
			canEditProject,
			applicableUsers,
			isPremium,
			setProjectScrollHeight,
			projectFolderChain,
			updateProjectFolderChain,
		} = this.props

		const {
			user,
			roles
		} = this.context

		const isArchivedProject = currentProject.deleted_at
		const isFavouritedProject = isProjectFavourited(currentProject, user)

		let pathname = location.pathname

		pathname = pathname.split('?')[0].split('/').filter(i => {
			return i !== ""
		}).slice(-1)[0]

		let mobilesubMenuOptions = [
			{
				icon: isFavouritedProject ? 'star' : 'star-o',
				label: isFavouritedProject ? 'Favourited' : 'Favourite',
				callback: this.favouriteProject
			}
		]

		if (!roles.guest) {
			mobilesubMenuOptions.push({
				icon: 'copy',
				label: 'Duplicate',
				callback: _ => { this.editProject(true) }
			})
		}

		if (canEditProject) {
			mobilesubMenuOptions = mobilesubMenuOptions.concat([
				{
					icon: isArchivedProject ? 'reply' : 'fe-edit-2',
					label: isArchivedProject ? 'Restore' : 'Edit Project',
					callback: isArchivedProject ? this.restoreProject : _ => { this.editProject(false, 'details') }
				},
				{
					icon: 'fe-user-plus',
					label: 'Manage Users & Guests',
					callback: isArchivedProject ? this.restoreProject : _ => { this.editProject(false, 'access') }
				},
				{
					icon: isArchivedProject ? 'fe-trash-2' : 'fe-trash-2',
					label: isArchivedProject ? 'Delete' : 'Archive',
					callback: this.deleteProject
				}
			])
		}

		return (
			<div className={'single-index'}>
				<header className="main-header">
					<h1>
						{currentProject.name}
						{currentProject.guestIds && currentProject.guestIds.length ?
							<div className="external-indicator tooltip-trigger">
								<Icon name="users" />
								<span>
									{currentProject.guestIds.length} Guest{currentProject.guestIds.length > 1 ? 's' : ''}
								</span>
								<div className="tooltip">
									<ul className="tooltip-user-list">
										{currentProject.guestIds.map(guestId => {
											const guest = applicableUsers.find(user => {
												return user.id == guestId
											})

											if (!guest) {
												return null
											}

											return (
												<li key={guestId}>
													<ProfilePicture user={guest} />
													<span>
														{guest.first_name + ' ' + guest.last_name}
													</span>
												</li>
											)
										})}
									</ul>
								</div>
							</div>
							:
							null
						}
						{isArchivedProject ?
							<div className="external-indicator archived">
								<Icon name="fe-trash-2" />
								<span>
									Archived
								</span>
							</div>
							: null
						}
					</h1>

					<div className="sub-title-area">
						{currentProject.folder_id && currentAccount.folders &&
							<ProjectBreadcrumbs type="project" currentProject={currentProject} currentAccount={currentAccount} />
						}
						{(currentProject.start_date || currentProject.end_date) &&
							<Dateprogress startDate={currentProject.start_date} endDate={currentProject.end_date} />
						}
					</div>
					<MobileSubMenu 
						options={mobilesubMenuOptions} 
						desktopLabel={'Actions'}
					/>
					<MainHeaderNav
						currentProject={currentProject}
						right={true}
						relUrl={match.url}
						callback={this.selectProjecttab}
						navtabs={this.navtabs}
						type='tabs'
					/>
				</header>
				<main>
					<SwitchCSSTransitionGroup
						location={location}
						transitionName="slide"
						transitionEnterTimeout={10}
						transitionLeaveTimeout={300}
					>
						{this.navtabs.map((object, i) => {
							return (
								<Route path={match.url + '/' + object.path} key={i} render={props => {
									let ThisComponent = object.component

									if (!currentProject.id) {
										return null
									}

									return (
										<ThisComponent
											applicableUsers={applicableUsers}
											hasHardSetState={hasHardSetState}
											loading={loading}
											currentProject={currentProject}
											isPremium={isPremium}
											isArchivedProject={isArchivedProject}
											path={object.path}
											setProjectScrollHeight={setProjectScrollHeight}
											projectFolderChain={projectFolderChain}
											updateProjectFolderChain={updateProjectFolderChain}
											{...props}
										/>
									);
								}} />
							)
						})}
						<Redirect from={match.url} exact to={match.url + '/tasks'} />
					</SwitchCSSTransitionGroup>
				</main>
			</div>
		);
	}
}

export default withRouter(connect(null, {
	openModal,
	changeTitle,
	favouriteProject,
	setOnboardingStep
})(ProjectIndex))

ProjectIndex.contextType = MainContext


// WEBPACK FOOTER //
// ./src/sections/projects/project/project-index.jsx